import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { useForm } from "react-hook-form";
import {
  reqUserContest,
  clearDeleteContest,
  addContestSearch,
  reqDeleteContest,
  contestId,
} from "../../store/contest/actions";
import {
  setZero,
  incresePage,
  decresePage,
  perPageEntries,
} from "../../store/data/actions";
import {
  Row,
  Col,
  Button,
  Spinner,
  Dropdown,
  DropdownToggle,
  DropdownItem,
  DropdownMenu,
} from "reactstrap";

const UserContest = () => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dispatch = useDispatch();
  const history = useHistory();
  const { register, handleSubmit } = useForm();
  const page = useSelector((state) => state.UserData.page);
  const perPage = useSelector((state) => state.UserData?.perPage);
  const search = useSelector((state) => state.Contest.addContestSearch);
  const currentPage = useSelector(
    (state) => state.Contest.userContest?.data?.current_page
  );
  const lastPage = useSelector(
    (state) => state.Contest.userContest?.data?.last_page
  );
  const deletedContest = useSelector(
    (state) => state.Contest.deleteContest?.success
  );
  const userContestToggle = useSelector(
    (state) => state.Contest.userContestToggle
  );
  const userContest = useSelector((state) => state.Contest.userContest);

  useEffect(() => {
    dispatch(reqUserContest({ page: page, limit: perPage, search: search }));
    if (currentPage > lastPage) {
      dispatch(setZero());
    } else if (deletedContest === 1) {
      alert("contest is deleted successfully");
      dispatch(clearDeleteContest());
    }
  }, [dispatch, page, perPage, currentPage, lastPage, search, deletedContest]);

  const toggle = () => setDropdownOpen((prevState) => !prevState);

  const onSubmit = (data) => {
    if (data.search !== search) {
      dispatch(addContestSearch(data.search));
    }
  };

  const viewContest = (id) => {
    // dispatch(contestId(id));
    history.push(`/contest-details/${id}`);
  };

  const deleteEvent = async (contest) => {
    if (
      window.confirm(`Are you sure, you want to delele ${contest.title} event?`)
    ) {
      dispatch(reqDeleteContest(contest.id));
    }
  };

  const viewParticipants = (id) => {
    dispatch(contestId(id));
    history.push(`/participants/${id}`);
  };

  const updateContest = (id) => {
    dispatch(contestId(id));
    history.push("/update-contest");
  };

  const changeApproval = (id) => {
    dispatch(contestId(id));
    history.push("/approval-form");
  };

  return (
    <React.Fragment>
      <div className="container-fluid">
        <Row className="align-items-center m-3">
          <Col>
            <Row className="align-items-center">
              <Button
                disabled={page <= 1}
                onClick={() => dispatch(decresePage(1))}
              >
                Prev.
              </Button>
              <h6 className="ml-4 mr-4">{currentPage}</h6>
              <Button
                disabled={page >= lastPage}
                onClick={() => dispatch(incresePage(1))}
              >
                Next
              </Button>
              <h6 className="ml-4 mr-4">Total Pages: {lastPage}</h6>
            </Row>
          </Col>
          <Col>
            <Dropdown isOpen={dropdownOpen} toggle={toggle}>
              <DropdownToggle caret>Per Page - {perPage}</DropdownToggle>
              <DropdownMenu>
                <DropdownItem onClick={() => dispatch(perPageEntries(5))}>
                  5
                </DropdownItem>
                <DropdownItem onClick={() => dispatch(perPageEntries(10))}>
                  10
                </DropdownItem>
                <DropdownItem onClick={() => dispatch(perPageEntries(20))}>
                  20
                </DropdownItem>
                <DropdownItem onClick={() => dispatch(perPageEntries(50))}>
                  50
                </DropdownItem>
                <DropdownItem onClick={() => dispatch(perPageEntries(100))}>
                  100
                </DropdownItem>
                <DropdownItem onClick={() => dispatch(perPageEntries(200))}>
                  200
                </DropdownItem>
              </DropdownMenu>
            </Dropdown>
          </Col>
          <Col>
            <form
              className="float-right d-md-flex"
              onSubmit={handleSubmit(onSubmit)}
            >
              <input
                className="form-control"
                type="text"
                {...register("search")}
                defaultValue={search}
                placeholder="search"
              />
              <Button className="ml-2" color="info" outline type="submit">
                Search
              </Button>
            </form>
          </Col>
        </Row>
        {userContestToggle && <Spinner color="dark" />}
        <div className="row">
          <div className="col-12">
            <div className="card">
              <div className="card-body">
                <h4 className="card-title">User Contests List</h4>
                <div className="table-rep-plugin">
                  <div
                    className="table-responsive mb-0"
                    data-pattern="priority-columns"
                  >
                    <table
                      id="tech-companies-1"
                      className="table table-striped"
                    >
                      <thead>
                        <tr>
                          <th>ID</th>
                          <th>Title</th>
                          {/* <th>Image</th> */}
                          <th>Starting Date</th>
                          <th>Ending Date</th>
                          <th>Contest Type</th>
                          <th>Status</th>
                          <th>Approval Status</th>
                          <th className="text-center">Actions</th>
                        </tr>
                      </thead>
                      {!userContestToggle && (
                        <tbody>
                          {userContest?.data?.data.map((contest) => (
                            <tr key={contest.id}>
                              <th>{contest.id || "--"}</th>
                              <th>{contest.title || "--"}</th>
                              {/* <th><img src={contest.thumb_img } loading='lazy' alt="contest_thumb" style={{width: '100px', height: '100px'}} /></th> */}
                              <th>{contest.s_date || "--"}</th>
                              <th>{contest.e_date || "--"}</th>
                              <th>{contest.type || "--"}</th>
                              <th>{contest.status || "--"}</th>
                              <th>
                                {contest.is_user_contest_approve === 1
                                  ? "pending"
                                  : contest.is_user_contest_approve === 0
                                  ? "Approved"
                                  : "Declined"}
                              </th>
                              <th
                                style={{
                                  display: "flex",
                                  justifyContent: "space-evenly",
                                }}
                              >
                                {/* <Button
                                  outline
                                  color="primary"
                                  onClick={() => viewContest(contest.id)}
                                >
                                  Details
                                </Button> */}

                                <Button
                                  outline
                                  color="info"
                                  className="ml-2 mr-2"
                                  onClick={() => viewParticipants(contest.id)}
                                >
                                  Participants
                                </Button>

                                <Button
                                  outline
                                  color="info"
                                  className="ml-2 mr-2"
                                  onClick={() => changeApproval(contest.id)}
                                >
                                  Change approval status
                                </Button>

                                <Button
                                  outline
                                  color="info"
                                  className="mr-2"
                                  onClick={() => updateContest(contest.id)}
                                >
                                  <i className="ti-pencil-alt"></i> Details
                                </Button>

                                <Button
                                  outline
                                  color="danger"
                                  onClick={() => deleteEvent({ ...contest })}
                                >
                                  <i className="ti-trash"></i>
                                </Button>
                              </th>
                            </tr>
                          ))}
                        </tbody>
                      )}
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default UserContest;
